import * as React from "react";
import type { SVGProps } from "react";
const SvgPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.931 11.118c.455.255.682.383.775.541a.68.68 0 0 1 0 .682c-.093.158-.32.286-.775.542l-9.174 5.16c-.366.206-.55.309-.7.308a.56.56 0 0 1-.482-.283c-.075-.13-.075-.34-.075-.76V6.692c0-.42 0-.631.075-.761.099-.173.283-.281.483-.283.15-.001.333.102.7.308z"
    />
  </svg>
);
export default SvgPlay;
